export default __webpack_public_path__ + "static/media/3_Ds.af1f9c20.svg";